import { action, computed, makeObservable, observable } from "mobx";
import ApiResponseHandler from "@eryxcoop/appyx-comm/src/errors/ApiResponseHandler";
import Feature from "../../Feature";
import errorToast from "../../../components/toast/ErrorToast";
import DashboardDateRangeValidity from "../DashboardDateRangeValidity";

export default class SalesByChannelFeature extends Feature {
    constructor(application, filters) {
        super(application);
        this._filters = filters;
        this._salesByChannel = null;

        makeObservable(this, {
            _salesByChannel: observable,
            salesByChannel: computed,
            setSalesByChannel: action,
        });
    }

    async load() {
        if (!DashboardDateRangeValidity.isValid(this._filters.fromDate, this._filters.toDate)) {
            return;
        }
        await this._getSalesByChannel();
        this.finishLoading();
    }

    setSalesByChannel(data) {
        this._salesByChannel = data;
    }

    get salesByChannel() {
        return this._salesByChannel;
    }

    async _getSalesByChannel() {
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: (response) => {
                this.setSalesByChannel(response.salesByChannel());
            },
            handlesError: () => {
                errorToast("No se pudieron obtener las ventas por canal");
                this.setSalesByChannel({ rows: [], total: null });
            },
        });
        return this._application.apiClient().getSalesByChannel(responseHandler, this._filters.fromDate,
                                                               this._filters.toDate, this._filters.channels,
                                                               this._filters.articleCategories,
                                                               this._filters.withoutAllowances);
    }
}
